/* app/js/src/components/layouts/layout-visual-editor/layout-visual-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  width: 100%;
  height: 100%;
  position: relative;
}
.zone {
  color: white;
  border: 1px solid black;
}
.zone:hover {
  opacity: 0.8;
}
.zone img {
  width: 100%;
  height: 100%;
  color: white;
}
.zone span {
  color: white;
  position: absolute;
  bottom: 0;
  font-size: 30px;
  text-shadow: 0 0 11px black;
}
.empty-zone h2 {
  text-align: center;
  color: black;
}
/*# sourceMappingURL=layout-visual-editor.component.css.map */
